var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "stream-prop" },
    [
      _c("span", { staticClass: "stream-prop__label" }, [_vm._v("Название:")]),
      _vm._v(" "),
      _vm.isAccessAllow
        ? [
            _vm.isEdit
              ? _c("EditText", {
                  attrs: { "cancel-title": "Удалить" },
                  on: { apply: _vm.onSaveEdit, cancel: _vm.onCancelEdit },
                  model: {
                    value: _vm.editable,
                    callback: function ($$v) {
                      _vm.editable = $$v
                    },
                    expression: "editable",
                  },
                })
              : _c("label", { staticClass: "d-flex align-items-center mb-0" }, [
                  _c(
                    "div",
                    { staticClass: "stream-prop__value" },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.stream.name))]),
                      _vm._v(" "),
                      _c("Icon", {
                        staticClass: "mr-1",
                        attrs: { id: "edit", title: "Редактировать" },
                        on: {
                          click: function ($event) {
                            _vm.isEdit = true
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
          ]
        : _c("div", { staticClass: "stream-prop__value" }, [
            _vm._v(_vm._s(_vm.stream.name)),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }